import type { NoodlNode, Props } from '@shared/node-v1.0.0'
import type { CollectionDefinitionScheme } from '../definition'
import { createLocalDocs, updateLocalDocs, deleteLocalDocs, fetchLocalDocs, getLocalDocsCount } from './core/operations'
import { ReplicationEngine } from './replication/replicationEngine'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import LocalFileEngine from './localFileEngine'
import Dexie from 'dexie'
import { liveQuery } from 'dexie'
import { applySorting, filterConvertation } from './core/filterConvertation'
// import 'dexie-observable';

// Данная функция должна принимать схему для создания классов, создавать их и публиковать функции для работы с ними в R.localData
export default async (p: Props, noodlNode: NoodlNode) => {
	const { project, environment = 'd3' } = Noodl.getProjectSettings()

	// Создаем экземпляр базы. Если её нет, то создастся, если есть, то подключится
	const localDB = new Dexie(`localDexieRolder-${project}-${environment}-${R.env.dbName}`)
	// Создадим классы, указанные в collectionsDefinition в базе
	const collectionsDefinition: CollectionDefinitionScheme[] = p?.collectionsDefinition || []

	// Создаем коллекции в базе
	for (const iCollection of collectionsDefinition) {
		localDB.version(iCollection.version).stores({
			[iCollection.collectionName]: iCollection.scheme,
		})
	}

	// Открываем базу - после этого она появляется на вклюадке Application в консоле браузера
	// 1. Создаётся физическое подключение к IndexedDB
	// 2. Проверяется версия базы
	// 3. Применяются схемы и индексы
	// 4. Выполняются миграции (если нужно)
	// 5. База становится готовой к операциям
	// Методы работы с документоами автоматически это делают, но лучше запускать заранее
	try {
		await localDB.open() // Вот тут реально создаётся/открывается база
	} catch (error) {
		console.error('Что-то пошло не так при открытии базы Dexie.js:', error)
	}
	// ========Публикация в R========
	// Получаем название коллекций, которые нужно реплицировать
	const syncCollections = collectionsDefinition.map((iCollection) => iCollection?.collectionName)

	console.log('R.env.dbName', R.env.dbName)

	// Создаем экземпляр репликатора и добавляем его в R
	const localDataReplicationEngine = await ReplicationEngine.create()

	// Фунцкия для синхронизации с Kuzzle по триггеру
	const refreshData = async () => {
		// Выставляем флаг replicating
		sendOutput(noodlNode, 'replicating', true)

		console.log('******************Чекаем связь****************************')
		// Чекаем связь
		// await localDataReplicationEngine.checkConnectionState();

		console.log('******************Запускаем пушер****************************')
		// Запускаем пушер
		await localDataReplicationEngine.pushHandler()

		console.log('******************Запускаем пуллер****************************')
		// Запускаем пуллер
		await localDataReplicationEngine.pullHandler()

		console.log('******************Получаем время на сервере****************************')
		// Получаем время на сервере
		const lastSuccessSync = await localDataReplicationEngine.finallySync()

		// Выдаем время последней синхронизации и сигнал окончания
		sendOutput(noodlNode, 'lastSuccessSync', lastSuccessSync)
		sendOutput(noodlNode, 'replicating', false)
		sendSignal(noodlNode, 'dataRefreshed')

		// Асинхронная функция должна что-то возвращать
		return lastSuccessSync
	}

	//Создаем экземпляр localFileEngine и добавляем
	const localFileEngine = new LocalFileEngine()

	// Публикуем в R.localData функции по работе с ней
	R.localData = {
		db: localDB,
		syncCollections,
		localDataReplicationEngine,
		localFileEngine,
		filterConvertation,
		applySorting,
		createLocalDocs,
		updateLocalDocs,
		deleteLocalDocs,
		fetchLocalDocs,
		liveQuery,
		getLocalDocsCount,
		refreshData,
	}

	// Чекаем связь, чтобы обновить статус подключения у экземпляра класса
	// await localDataReplicationEngine.checkConnectionState();

	// Получаем из базы и присваиваем экземпляру класса время последней синхронизации
	await localDataReplicationEngine.getLastSuccessSync()

	// Подаем на выход время последней синхронизации
	sendOutput(noodlNode, 'lastSuccessSync', localDataReplicationEngine.getLastSuccessSync())

	return Promise.resolve({
		localDB,
		// collections: db.collections,
		// replicationEngine: localDataReplicationEngine,
	})
}
